<div></div>
<h1 mat-dialog-title tabindex="-1" cdkFocusInitial>Email Verification</h1>
<div mat-dialog-content>
    <p>Your Account Doesn't Verified. Click <b>Verify Email </b> to Get Verification Email.</p>
</div>
<div fxLayoutAlign="center" fxLayout="column" fxLayout.gt-xs="row" class="button-group" fxLayoutGap="20px">
    <a mat-flat-button color="primary" mat-dialog-close (click)="verifyEmail()">Verify Email</a>
    <a mat-flat-button color="primary" mat-dialog-close>Cancel</a>
</div>